export default "__VITE_ASSET__BEN2AeiP__"